var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: _vm.show } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "300" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.message))]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [_c("w-progress-circular", { attrs: { large: "" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }